// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Fuby","left":"StickyBox_left__1sIHV","right":"StickyBox_right__1RGMF"};